import { RouteConfig } from 'vue-router';
import SandboxAutoRenewals from './sandbox-auto-renewals.vue';
const route : RouteConfig = {
  path:  'autorenewals',
  component: SandboxAutoRenewals,
};

export default route;
